import { render, staticRenderFns } from "./VoiceData.vue?vue&type=template&id=28ab3fb2&scoped=true"
import script from "./VoiceData.vue?vue&type=script&lang=js"
export * from "./VoiceData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ab3fb2",
  null
  
)

export default component.exports